import request from '@/utils/request'
let OrderApi = {
    /*订单列表*/
    orderlist(data) {
        return request._post('/shop/order.order/index', data);
    },
    /*订单详情*/
    orderdetail(data) {
        return request._post('/shop/order.order/detail', data);
    },

    /* 新增：取消订单 */
    cancelOrder(data) {
        return request._post('/shop/order.order/cancelOrder', data);
    },

    /*批量发货*/
    batchDelivery(formData) {
      return request._upload('/shop/order.operate/batchDelivery', formData);
    },
    /*售后管理*/
    orderrefund(data) {
        return request._post('/shop/order.refund/index', data);
    },
    /*去发货*/
    delivery(data) {
        return request._post('/shop/order.order/delivery', data);
    },
    /*去配送*/
    deliveryStaff(data) {
        return request._post('/shop/order.order/deliveryStaff', data);
    },
    /*确认审核*/
    confirm(data) {
        return request._post('/shop/order.Operate/confirmCancel', data);
    },
    /*售后详情*/
    refundDetail(data) {
        return request._get('/shop/order.refund/detail', data);
    },
    /*售后审核*/
    Approval(data) {
        return request._get('/shop/order.refund/audit', data);
    },
    /*确认收货并退款*/
    receipt(data) {
        return request._post('/shop/order.refund/receipt', data);
    },
    /*核销*/
    extract(data) {
        return request._post('/shop/order.operate/extract', data);
    },
    /*修改价格*/
    updatePrice(data) {
        return request._post('/shop/order.order/updatePrice', data);
    },
    /*记录列表*/
    accountlog(data) {
        return request._get('/shop/order.order/accountlog', data);
    },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js